"use strict";

import { MenuItem } from "@mui/material";
import React from "react";

import { useProjectMediaPlayback } from "../hooks/useProjectMediaPlayback";

export const ProjectMediaLink = ({ reference, projectId, children, ...props }) => {
  const { playbackUrl } = useProjectMediaPlayback({ reference, projectId });
  return (
    <a {...props} href={playbackUrl || undefined} aria-disabled={!playbackUrl}>
      {children}
    </a>
  );
};

export const ProjectMediaMenuItem = ({
  reference,
  projectId,
  children,
  ...props
}) => {
  const { playbackUrl } = useProjectMediaPlayback({ reference, projectId });
  return (
    <MenuItem {...props} value={playbackUrl || ""} disabled={!playbackUrl}>
      {children}
    </MenuItem>
  );
};
